function sheet(show) {
  if (typeof(show) == 'undefined' || show) {
    $('body').append('<div id="default-generated-sheet-loading"></div><div id="default-generated-sheet"></div>');
  } else {
    $('#default-generated-sheet-loading, #default-generated-sheet').remove();
  }
  return false;
}

function sheet_loading(action) {
  switch (action) {
    case 'show':
      if ($('body').find('#sheet_loading').length){
        $('#sheet_loading').show();
      } else {
        $('<div id="sheet_loading" />').appendTo(document.body).appendTo(document.body).show();
      }
    break;
    case 'hide':
      $("#sheet_loading").hide();
    break;
  }
}

function submit_form_sync(context) {
  $(context).parents('form').attr('onSubmit', '').submit();
  return false;
}

function submit_form(context, success, failure) {
  sheet();
  $(context).parents('form').ajaxSubmit(function(answer) {
    handle_answer(answer, context, success, failure);
  });
  return false;
}

function handle_answer(answer, context, success, failure) {
  var failure_func = (failure == 'alert' ? alert_message : failure);
  
  if (!answer) {
    return (failure ? failure_func.call((context ? context : this), ['Некорректный ответ сервера']) : sheet(false));
  }
  
  try {
    answer = $.parseJSON(answer);
  } catch (e) {
    return (failure ? failure_func.call((context ? context : this), answer) : sheet(false));
  }

  if (typeof(answer.errors) == 'object' && !$.isEmptyObject(answer.errors)) {
    return (failure ? failure_func.call((context ? context : this), answer.errors, (context ? context : this)) : sheet(false));
  }
  
  if (!success) {
    return sheet(false);
  }
  
  if (typeof(success) == 'function') {
    return success.call((context ? context : this), answer);
  }
  
  if (success == 'reload') {
    document.location.reload();
  } else {
    document.location = success;
  }
  
  return false;
}

function alert_message(message) {
  if (typeof(message) == 'object') {
    message = message.join("\n");
  }
  alert(message);
  sheet(false);
  return false;
}

function timer(element) {
  var timer = 0;
  var hour = 0;
  var minute = 0;
  var second = 0;
  var timerId = window.setInterval(function(){
    ++timer;
    hour   = Math.floor(timer / 3600);
    minute = Math.floor((timer - hour * 3600) / 60);
    second = timer - hour * 3600 - minute * 60;
    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;
    if (second < 10) second = '0' + second;
    $(element).html(minute + ':' + second);
    window.globalTimer = timer;
  }, 1000);  
  return timerId;
}

function timerStop(timerId,element) {
  clearInterval(timerId);
  var timer = hour = minute = second = 0;
  window.globalTimer = timer;
  $(element).html(minute + ':' + second);
}

var $submitTimeoutId = 0, paramsForm = {obj:'', dataType:'', postfix:'', param:'', recaptchaObj: {}};
function submitForm(obj, dataType, postfix, param) {
  //сделано чтобы избежать двойной отправки формы при двойном щелчке по кнопке
  if(!$submitTimeoutId){
    paramsForm.obj = obj;
    paramsForm.dataType = dataType;
    paramsForm.postfix = postfix;
    paramsForm.param = param;
    
    _submitForm(paramsForm);

    $submitTimeoutId = setTimeout(function(){
      clearTimeout($submitTimeoutId);
      $submitTimeoutId = 0;
    },500)
  }
}

// Для невидимой рекапчи 
function callbackRecaptchaSubmit() {
  _submitForm(paramsForm)
}

function _submitForm(paramsForm) {
  var form, formData;

  form = $(paramsForm.obj).parents('form');

  if (form.data('type') !== 'html') {
    sheet_loading('show');
  }

  formMethod = (typeof(form.attr('method')) !== 'undefined' && form.attr('method').toUpperCase() === 'GET' ? 'GET' : "POST");
  if(formMethod === 'GET'){
    formData = form.serialize();
  } else {
    formData = new FormData(form[0]);
  }


  form.find('.b-form__item, .form-group, .b-form__item, .jq-checkbox, .jq-radio').removeClass('error').removeClass('has-error');
  form.find('.error').text("").removeClass('alert alert-danger');

  // если в форме найдена невидимая рекапча, запускаем ее в проверку
  if(form.find('.g-recaptcha[data-size="invisible"]').length && typeof grecaptcha != 'undefined'){
    var recaptcha = form.find('.g-recaptcha[data-size="invisible"]');
    paramsForm.recaptchaId = recaptcha.attr('id');

    // используется для невидимой рекапчи
    if(typeof paramsForm.recaptchaObj[paramsForm.recaptchaId] === 'undefined'){
      paramsForm.recaptchaObj[paramsForm.recaptchaId] = grecaptcha.render(paramsForm.recaptchaId, {
        'sitekey' : recaptcha.data('sitekey'),
        'size'    : 'invisible',
      });
      grecaptcha.execute(paramsForm.recaptchaObj[paramsForm.recaptchaId]);
      return;
    } else if(!grecaptcha.getResponse(paramsForm.recaptchaObj[paramsForm.recaptchaId])) {
      grecaptcha.execute(paramsForm.recaptchaObj[paramsForm.recaptchaId]);
      return;
    }
  }

  var items = form.find('label');
  $.each(items,function(){
    // если не checkbox или radio
    if(!$(this).find('input').length){
      $(this).html($(this).data('text'));
    }
  })
  if(form.data('type')=='html'){
    var selector = (form.data('selector') ? form.data('selector') : '#ias_results');
    $(selector).html("");
    $(selector).addClass("loading");
  }
  var path = form.attr('action')+(typeof(paramsForm.postfix) != 'undefined' ? paramsForm.postfix : '');
  console.log(path)
  
  var options = {
    url: path,
    cache: false,
    async: true,
    timeout: 60000,
    processData: false,
    contentType: false,
    headers: {
      "cache-control": "no-cache"
    },
    type: formMethod,
    data: formData,
    target:        '#form_captcha', // target element(s) to be updated with server response 
    beforeSubmit:  showRequest,     // pre-submit callback 
    success:       showResponse,    // post-submit callback 
    error:         function(error){
                    // console.log(error);
                    if (error.status === 400 && error.responseJSON) {
                      return showResponse(error.responseJSON);
                    }
                    var html = '<h3>Некорректный ответ сервера!</h3><br/><p>Пожалуйста,&nbsp;позвоните&nbsp;по&nbsp;номеру&nbsp;8(343)278-60-06</p>';
                    if(form.data('param') == 'hosting'){
                      html = '<h3>Некорректный ответ сервера!</h3><p>Проверте, указанный в заявке, email.</p><p>Если Вы не получили реквизиты и счет на оплату,</p><p> пожалуйста, позвоните по номеру: (343) 380-26-26.</p>';
                    }
                    if(typeof $.fancybox != 'undefined'){
                      $.fancybox({
                        'href' : '#fanks-popup',
                        'padding': 20,
                        fitToView   : false,
                        autoSize    : true,
                        closeClick  : false,
                        type        : 'html',
                        content     : html,
                        scrolling   : 'none'
                      });                      
                    }
                    sheet_loading('hide');
                  },
    dataType:     (typeof(paramsForm.dataType) != 'undefined' && paramsForm.dataType ? paramsForm.dataType : 'json')
  };

  // form.ajaxSubmit(options);

  $.ajax(options);
  
  return false;
}

function showRequest(formData, jqForm, options) {
  return true;
} 
 
function showResponse(response, statusText, xhr)  {
  var $form = $(paramsForm.obj).parents('form');

  switch ($form.data('type')) {
    case 'html':
      sheet_loading('hide');
      var selector = ($form.data('selector') ? $form.data('selector') : '#ias_results');
      var results = $(response).find(selector);
      if(results.length){
        $(document).find(selector).html(results.html());
      } else {
        $(document).find(selector).html(response);
      }
      if(typeof $.fn.styler !== 'undefined' && $(document).find(selector).find('input[type="checkbox"]').length){
        $('input[type="checkbox"]').styler();
      }
      $(selector).removeClass("loading");
      if(typeof $.fn.styler !== 'undefined' && $(document).find(selector).find('input[type="radio"]').length){
        $('input[type="radio"]').styler();
      }
      
      if (typeof $.fn.perfectScrollbar === "function") {
        $('.perfectScrollbar').perfectScrollbar('destroy');
        $('.perfectScrollbar').perfectScrollbar({ suppressScrollX : false }, 10);
      }

      if (typeof $.fn.tooltip === "function") {
        $('[data-toggle="tooltip"]').tooltip({
          container: 'body',
          html: true
        });
      }
    break;
    default:
      if (typeof(response) != 'undefined') {
        if (typeof(response.errors) != 'undefined' && response.errors != ""){
          var input,error;
          $.each(response.errors, function(key,item){
            item = $.parseHTML(item);
            item = $('<div/>').html(item).text()
            input = $form.find('[name="'+key+'"]');
            if (input.length){
              input.parents('.b-form__item').addClass('error');
              input.parents('.form-group').addClass('has-error');
              switch(input.attr('type')){
                case 'checkbox':
                  input.parents('.jq-checkbox').addClass('error');
                break;
                case 'radio':
                  input.parents('.jq-radio').addClass('error');
                break;
                default:
                  if(input.parents('.b-form__item').find('label').length){
                    input.parents('.b-form__item').find('label').html(item);
                  } else {
                    error = input.parents('.b-form__item').find('.error');
                    if(!error.length){
                      input.parents('.b-form__item').prepend('<div class="error"></div>');
                      error = input.parents('.b-form__item').find('.error');
                    }
                    error.html(item);
                  }
                  if(input.parents('.form-group').find('label').length){
                    input.parents('.form-group').find('label').html(item);
                  } else {
                    error = input.parents('.form-group').find('.error');
                    if(!error.length){
                      input.parents('.form-group').prepend('<div class="error"></div>');
                      error = input.parents('.form-group').find('.error');
                    }
                    error.html(item);
                  }
                break;
              }
              pos = input.parent().offset();
              // scrollPage(pos.top,30);
            } else {
              error = $form.children('.error');
              if(!error.length){
                error = $form.find('.form-errorContainer');
              }
              if(!error.length){
                $form.prepend('<div class="error b-form__label"></div>');
                error = $form.children('.error');
              }
              error.addClass('alert alert-danger');
              $(error).html(item);
              pos = error.offset();
              // scrollPage(pos.top,30);
            }
            console.log(item);
            sheet_loading('hide');
          })
        } else if (typeof(response.submit_form_sync) != 'undefined') {
          //Функции для гугл аналитика
          // if(typeof(response.ga) != 'undefined') {
          //   send_ga(response.ga.num, response.ga.tariff_id, response.ga.user_id);
          // }
          //Функции для yandex метрики
          if(typeof(response.ya) != 'undefined') {
            send_ya(response.ya.num);
          }
          if (typeof(response.action) != 'undefined') {
            $form.attr('action',response.action);
          }
          $form.attr('onSubmit', '').submit();
        } else if (typeof(response.redirect_url) != 'undefined') {
          //Функции для гугл аналитика
          // if(typeof(response.ga) != 'undefined') {
          //   send_ga(response.ga.num, response.ga.tariff_id, response.ga.user_id);
          // }
          //Функции для yandex метрики
          if(typeof(response.ya) != 'undefined') {
            send_ya(response.ya.num);
          }
          document.location = response.redirect_url.replace(/&amp;/g,'&');
        } else if (typeof(response.success) != 'undefined' && response.success !== false) {
          //Функции для гугл аналитика
          // if(typeof(response.ga) != 'undefined') {
          //   send_ga(response.ga.num, response.ga.tariff_id, response.ga.user_id);
          // }
          //Функции для yandex метрики
          if(typeof(response.ya) != 'undefined') {
            send_ya(response.ya.num, (typeof response.ya.params != 'undefined' ? response.ya.params : {}));
          }
          if (typeof(response.success.html) != 'undefined') {
            var element = (response.success.html.element != 'undefined' ? response.success.html.element : '');
            var result = (response.success.html.result != 'undefined' ? response.success.html.result : '');
            result = $.parseHTML(result);
            result = $(result).html(result).text();
            var results = $(result).find(element);
            if(results.length){
              $(document).find(element).html(results.html());
            } else {
              $(document).find(element).html(result);
            }
            sheet_loading('hide');
          } else if(typeof(response.success.payment) != 'undefined' && typeof(response.success.payment.paymentQRcode) != 'undefined') {
            $('.box_pay_QRcode').html('');
            setTimeout(function(){
              $('.box_pay_QRcode').html('<img src="data:image/jpeg;base64,'+response.success.payment.paymentQRcode+'">');
            }, 100);
            sheet_loading('hide');
          } else if(typeof(response.success.payment) != 'undefined') {
            var html = '<h3>Платеж #'+response.success.payment.order_id+'</h3>';
            html += '<div class="b-form__item b-h4" style="width:455px;color:#51b1a9">Внимательно проверьте реквизиты операции</div><div class="b-clear"></div>';
            html += '<div class="b-form__item"><b>Логин или ID для оплаты:</b> </div>';
            html += '<div class="b-form__item">'+response.success.payment.params.username+'</div><div class="b-clear"></div>';
            html += '<div class="b-form__item"><b>Сумма</b>: </div>';
            html += '<div class="b-form__item">'+response.success.payment.params.PAY_SUM+' руб.</div>';
            html += '<form action="'+response.success.payment.url+'" method="POST">';
            $.each(response.success.payment.params, function( key, value ) {
              html += '<input type="hidden" name="'+key+'" value="'+value+'">';
            });
            html += '<div class="text-center"><input type="submit" value="Продолжить" class="b-btn b-btn_big"/></div><br/>';
            html += '</form>';
            $.fancybox({
              'href' : '#fanks-popup',
              'padding': 20,
              fitToView   : false,
              autoSize    : true,
              closeClick  : false,
              type        : 'html',
              content     : html,
              scrolling   : 'none'
            });
            sheet_loading('hide');
          } else {
            if(typeof(response.success.function) != 'undefined') {
              funcSuccess = window[response.success.function];
              if($.isFunction(funcSuccess)){
                sheet_loading('hide');
                return funcSuccess(response, $form);
              }
            } 

            setTimeout(function(){
              //тикет 9985 отключаем всплывающее окно, делаем редирект на страницу с сообщением
              document.location = '/success/';
              return false;
            }, 500);
          }
        }
      } else {
        console.log(response);
      }
    break;
  }
  
  // используется для невидимой рекапчи
  if(typeof paramsForm.recaptchaObj[paramsForm.recaptchaId] != 'undefined'){ grecaptcha.reset(paramsForm.recaptchaObj[paramsForm.recaptchaId]); }
  return false;
}

function scrollPage(top,interval){
  if($(document).scrollTop() > top){
    //плавная прокрутка страницы наверх
    var setIntervalId = setInterval(function(){
      $(document).scrollTop($(document).scrollTop() - interval);
    }, 10);
    $(document).scroll(function(){
      if ($(document).scrollTop() < top+10) {
        clearInterval(setIntervalId);
        setIntervalId = 0;
      }
    })    
  }
}

/**
* События для гугл аналитика, чтобы отследить сценарии взаимодействия пользователей с сайтом.
**/
//сделано чтобы избежать двойного срабатывания события
var $submitGaTimeoutId = 0;
function send_ga(num, tariff_id, user_id) {
  if(!$submitGaTimeoutId){
    $submitGaTimeoutId = setTimeout(function(){
      _send_ga(num, tariff_id, user_id);
      clearTimeout($submitGaTimeoutId);
      $submitGaTimeoutId = 0;
    },300)
  }
}
function _send_ga(num, tariff_id, user_id) {
  console.log('send_ga',num, tariff_id, user_id);
  switch (num) {
    case 1: //кнопка “подключиться сейчас”  для домашних пользователей      
      ga('send', 'event', 'home', 'click', 'glav');
      ga('send', 'pageview', '/home_click_glav');
    break;
    case 2: //кнопка “подключиться сейчас”  для корпративных клиентов
      ga('send', 'event', 'corp', 'click', 'glav');
      ga('send', 'pageview', '/corp_click_glav');
    break;
    case 3: //“подключиться сейчас” Успешная отправка заявки физиками
      ga('send', 'event', 'home', 'submit');
      ga('send', 'pageview', '/home_submit_glav');
    break;
    case 4: //“подключиться сейчас” Успешная отправка заявки юриками
      ga('send', 'event', 'corp', 'click', 'glav');
      ga('send', 'pageview', '/corp_click_glav');
    break;  
    case 5: //Телевидиение Клик по ссылке подключить телевидение у физиков
      ga('send', 'event', 'home', 'click', 'tv');
      ga('send', 'pageview', '/home_click_tv');
    break;  
    case 6: //Телевидиение Клик по ссылке подключить телевидение у юриков 
      ga('send', 'event', 'corp', 'click', 'tv');
      ga('send', 'pageview', '/corp_click_tv');
    break;  
    case 7: //Интернет Для офиса Интернет.Заявка Успешная отправка заявки
      ga('send', 'event', 'corp', 'submit', 'internet');
      ga('send', 'pageview', '/corp_submit_internet');
    break;  
    case 8: //Интернет клик по кнопке “подключить инетрнет” для физиков
      ga('send', 'event', 'home', 'click', 'internet', tariff_id);
      ga('send', 'pageview', '/home_click_internet');
    break;  
    case 9: //Интернет клик по кнопке “подключить инетрнет” для физиков в помегабайтных тарифах
      ga('send', 'event', 'home', 'click', 'internet', 'mb');
      ga('send', 'pageview', '/home_click_internet');
    break;  
    case 10: //Интернет Для дома Интернет.Заявка Успешная отправка заявки
      ga('send', 'event', 'home', 'submit', 'internet', tariff_id);
      ga('send', 'pageview', '/home_submit_internet');
    break;  
    case 11: //Интернет клик по кнопке “подключить инетрнет” для юриков 
      ga('send', 'event', 'corp', 'click', 'internet');
      ga('send', 'pageview', '/corp_click_internet');
    break;  
    case 12: //Телефония  Кнопка подключить телефон для ФЛ
      ga('send', 'event', 'home', 'click', 'tel', tariff_id);
      ga('send', 'pageview', '/home_click_tel');
    break;  
    case 13: //Телефония  Успешная отпрвака заявки ФЛ 
      ga('send', 'event', 'home', 'submit', 'tel');
      ga('send', 'pageview', '/home_submit_tel');
    break;  
    case 14: //Телефония Кнопка подключить телефон для ЮЛ 
      ga('send', 'event', 'corp', 'click', 'tel', tariff_id);
      ga('send', 'pageview', '/corp_click_tel');
    break;
    case 15: //Телефония Успешная отпрвака заявки ЮЛ
      ga('send', 'event', 'corp', 'submit', 'tel');
      ga('send', 'pageview', '/corp_submit_tel');
    break;
    case 16: //Переход в личный кабинет для ФЛ и ЮЛ Событие на ссылку 
      ga('send', 'event', 'LK', 'click');
      ga('send', 'pageview', '/lk_click');
    break;  
    case 17: //Переход в личный кабинет для ФЛ и ЮЛ Событие на кнопку “Войти” независимо от того, авторизовался юзер или нет 
      ga('send', 'event', 'LK', 'login');
      ga('send', 'pageview', '/lk_login');
    break;  
    case 18: //Баннер Медиасока на главной странице и на внутренних
      ga('send', 'event', 'banner', 'mediasok');
    break;
    case 19: //Пакеты Клик по кнопке “подключить” для каждого тарифа 
      ga('send', 'event', 'home', 'click', 'paket', tariff_id);
      ga('send', 'pageview', '/home_click_paket');
    break;
    case 20: //Пакеты Отправка заявки 
      ga('send', 'event', 'home', 'submit', 'paket', tariff_id);
      ga('send', 'pageview', '/home_submit_paket');
    break; 
    case 21: //Уведомление о необходимости внесения абонентской платы. Закрытие окна.
      ga('send', 'event', 'popupInformClient', 'click', 'close');
      ga('send', 'pageview', '/popupInformClient_click_close');
    break;   
    case 22: //Уведомление о необходимости внесения абонентской платы. Переход на оплату.
      ga('send', 'event', 'popupInformClient', 'click', 'pay');
      ga('send', 'pageview', '/popupInformClient_click_pay');
    break;   
    case 23: //Клик по кнопке "Опции и бонусы" на главной странице
      ga('send', 'event', 'home', 'click', 'bonuses', 'main_btn');
      ga('send', 'pageview', '/home_click_bonuses');
    break;
    case 24: //"Тарифные опции" клик по кнопке “оставить заявку”
      ga('send', 'event', 'home', 'click', 'tariff_options', tariff_id);
      ga('send', 'pageview', '/home_click_tariff_options');
    break; 
    case 25: //"Оплата банковской картой" клик по кнопке "Оплатить"
      ga('send', 'event', 'home', 'click', 'pay_online', user_id);
      ga('send', 'pageview', '/home_click_pay_online');
    break;
    case 26: //"Оплата банковской картой" успешное оформление заказа на оплату
      ga('send', 'event', 'home', 'submit', 'pay_online', user_id);
      ga('send', 'pageview', '/home_submit_pay_online');
    break;
    case 27: //Лендинг. Цифровое ТВ. Клик по кнопке "отправить" в форме
      ga('send', 'event', 'landing', 'click', 'tv');
      ga('send', 'pageview', '/landing_click_tv');
    break;  
    case 28: //Лендинг. Цифровое ТВ. Успешная отправка заявки
      ga('send', 'event', 'landing', 'submit', 'tv');
      ga('send', 'pageview', '/landing_submit_tv');
    break;
    case 29: //Лендинг. IT-аутсорсинг. Клик по кнопке "отправить" в форме
      ga('send', 'event', 'landing', 'click', 'outsourcing');
      ga('send', 'pageview', '/landing_click_outsourcing');
    break;  
    case 30: //Лендинг. IT-аутсорсинг. Успешная отправка заявки
      ga('send', 'event', 'landing', 'submit', 'outsourcing');
      ga('send', 'pageview', '/landing_submit_outsourcing');
    break; 
    case 31: //Лендинг. "А с инсис лучше". Клик по кнопке "отправить" в форме http://www.profintel.ru/corp-sale/ 
      ga('send', 'event', 'landing', 'click', 'corp_sale');
      ga('send', 'pageview', '/landing_click_corp_sale');
    break;  
    case 32: //Лендинг. "А с инсис лучше". Успешная отправка заявки
      ga('send', 'event', 'landing', 'submit', 'corp_sale');
      ga('send', 'pageview', '/landing_submit_corp_sale');
    break; 
    case 33: //Для офиса. Интернет. Включение чекбокса Нужен Wi-Fi
      ga('send', 'event', 'corp', 'click', 'wi_fi');
      ga('send', 'pageview', '/corp_click_wi_fi');
    break;
    case 34: //Телевидиение Успешная отправка заявки у физиков
      ga('send', 'event', 'home', 'submit', 'tv');
      ga('send', 'pageview', '/home_submit_tv');
    break;  
    case 35: //Телевидиение Успешная отправка заявки у юриков 
      ga('send', 'event', 'corp', 'submit', 'tv');
      ga('send', 'pageview', '/corp_submit_tv');
    break;
    case 36: //Лендинг. Виртуальный офис. Клик по кнопкам "отправить" и "Оставить заявку" на странице
      ga('send', 'event', 'landing', 'click', 'vats');
      ga('send', 'pageview', '/landing_click_vats');
    break;  
    case 37: //Лендинг. Виртуальный офис. Успешная отправка заявки
      ga('send', 'event', 'landing', 'submit', 'vats');
      ga('send', 'pageview', '/landing_submit_vats');
    break;  
    case 38: //Виртуальный офис. Успешная отправка заявки
      ga('send', 'event', 'corp', 'submit', 'virtual_office');
      ga('send', 'pageview', '/corp_submit_virtual_office');
    break; 
    case 39: //Розыск абонентов. Успешная отправка заявки
      ga('send', 'event', 'form', 'send', 'abonent');
      ga('send', 'pageview', '/form_send_abonent');
    break; 
    case 40: //Лендинг. Виртуальный офис. Клик по кнопкам "выбрать" и "Оставить заявку"
      // используется для отдельного счетчика на vats.profintel.ru
      ga('send', 'event', 'button', 'click', 'vats_form');
      ga('send', 'pageview', '/button_click_vats_form');
    break; 
    case 41: //Лендинг. Виртуальный офис. Успешная отправка заявки
      // используется для отдельного счетчика на vats.profintel.ru
      ga('send', 'event', 'form', 'submit', 'vats_order');
      ga('send', 'pageview', '/form_submit_vats_order');
    break;
    case 42: //Видеонаблюдение  Кнопка подключить ФЛ
      ga('send', 'event', 'home', 'click', 'video', tariff_id);
      ga('send', 'pageview', '/home_click_video');
    break;  
    case 43: //Видеонаблюдение  Успешная отпрвака заявки ФЛ 
      ga('send', 'event', 'home', 'submit', 'video');
      ga('send', 'pageview', '/home_submit_video');
    break;  
    case 44: //Видеонаблюдение Кнопка подключить ЮЛ 
      ga('send', 'event', 'corp', 'click', 'video', tariff_id);
      ga('send', 'pageview', '/corp_click_video');
    break;
    case 45: //Видеонаблюдение Успешная отпрвака заявки ЮЛ
      ga('send', 'event', 'corp', 'submit', 'video');
      ga('send', 'pageview', '/corp_submit_video');
    break;
  }
}

/**
* События для яндекс метрики, чтобы отследить сценарии взаимодействия пользователей с сайтом.
**/
var $submitYaTimeoutId = 0;
function send_ya(num, params) {
  if(!$submitYaTimeoutId){
    if(typeof params === 'undefined') params = {};
    $submitYaTimeoutId = setTimeout(function(){
      _send_ya(num, params);
      clearTimeout($submitYaTimeoutId);
      $submitYaTimeoutId = 0;
    },300)
  }
}
function _send_ya(num, params) {
  console.log('send_ya', num, params);

  switch (num) {
    case 1: //клик по кнопке "отправить заявку" «Для дома – Интернет»
      yaCounter623317.reachGoal('internet_home');
      return true;
    break;
    case 2: //клик по кнопке "отправить заявку" «Для офиса – Интернет»
      yaCounter623317.reachGoal('internet_office');
      return true;
    break;
    case 3: //клик по кнопке "отправить заявку" «Для дома – Телефония»
      yaCounter623317.reachGoal('phone_home');
      return true;
    break;
    case 4: //клик по кнопке "отправить заявку" «Для офиса – Телефония»
      yaCounter623317.reachGoal('phone_office');
      return true;
    break;
    case 5: //клик по кнопке "отправить заявку" «Для дома – Телевидение»
      yaCounter623317.reachGoal('tv_home');
      return true;
    break;
    case 6: //клик по кнопке "отправить заявку" «Для офиса – Телевидение»
      yaCounter623317.reachGoal('tv_office'); 
      return true;
    break;
    case 7: //клик по кнопке "отправить заявку" «Для дома – Пакеты Услуг»
      yaCounter623317.reachGoal('pack_home');
      return true;
    break;
    case 8: //клик по кнопке "отправить заявку" «Веб услуги»
      yaCounter623317.reachGoal('web');
      return true;
    break;
    case 9: //Розыск абонентов. Успешная отправка заявки
      yaCounter37063910.reachGoal('sendform_ok');
      return true;
    break;
    case 10: //Лендинг. Виртуальный офис. Клик по кнопкам "выбрать" и "Оставить заявку"
      // используется для отдельного счетчика на vats.profintel.ru
      yaCounter37668485.reachGoal('button_click');
    break; 
    case 11: //Лендинг. Виртуальный офис. Успешная отправка заявки
      // используется для отдельного счетчика на vats.profintel.ru
      yaCounter37668485.reachGoal('sendform_ok');
    break;
    case 12: //Розыгрыш с Незлобиным
      // используется для отдельного счетчика на nezlob.profintel.ru
      // Шаг 1. Ввод номера телефона друга. Клик на кнопку Далее.
      yaCounter40771119.reachGoal('nezlob_step_1');
    break;
    case 13: //Розыгрыш с Незлобиным
      // используется для отдельного счетчика на nezlob.profintel.ru
      // Шаг 2. Ввод своего номера телефона. Клик на кнопку Далее.
      yaCounter40771119.reachGoal('nezlob_step_2');
    break;
    case 14: //Розыгрыш с Незлобиным
      // используется для отдельного счетчика на nezlob.profintel.ru
      // Шаг 3. Введите код. Клик на кнопку Далее.
      yaCounter40771119.reachGoal('nezlob_step_code');
    break;
    case 15: //Розыгрыш с Незлобиным
      // используется для отдельного счетчика на nezlob.profintel.ru
      // Клик по кнопке "Подключить" Красавчик На всех шагах
      yaCounter40771119.reachGoal('nezlob_zayavka');
    break;
    case 16: //Розыгрыш с Незлобиным
      // используется для отдельного счетчика на nezlob.profintel.ru
      // Шаг 5. Клик по кнапке "Разыграть друга"
      yaCounter40771119.reachGoal('nezlob_popalsya');
    break;
    case 17: //клик по кнопке "отправить заявку" «Системная интеграция. СКУД.»
      yaCounter623317.reachGoal('access_control_si');
      return true;
    break;
    case 18: //клик по кнопке "отправить заявку" «Системная интеграция. ОПС.»
      yaCounter623317.reachGoal('fire_safety');
      return true;
    break;
    case 19: //клик по кнопке "отправить заявку" «Системная интеграция. СКС.»
      yaCounter623317.reachGoal('local_net');
      return true;
    break;
    case 20: //успешная отправка заявки на Демодоступ видеонаблюдения
      yaCounter623317.reachGoal('demovideo');
      return true;
    break;
    case 21: //успешная отправка заявки формы Обратный звонок
      yaCounter623317.reachGoal('obratniy_zvonok');
      return true;
    break;
    case 22: //успешная отправка заявки ВАТС
      yaCounter623317.reachGoal('vats');
      return true;
    break;
    case 23: //НИСКОЛЬКО клик по кнопке Только интернет
      yaCounter45504519.reachGoal('tolko_internet');
      return true;
    break;
    case 24: //НИСКОЛЬКО успешная отправка заявки без тарифа
      yaCounter45504519.reachGoal('bez_tariffa');
      return true;
    break;
    case 25: //НИСКОЛЬКО успешная отправка заявки с тарифом
      yaCounter45504519.reachGoal('tariff');
      return true;
    break;
    case 26: //НИСКОЛЬКО успешная отправка из формы "Остались вопросы"
      yaCounter45504519.reachGoal('calling');
      return true;
    break;
    case 27: //INVIDEO успешная отправка заявки
      yaCounter50277295.reachGoal('zayavka');
      return true;
    break;
    case 28: //INVIDEO Переход на сайт Инсис
      yaCounter50277295.reachGoal('site_insys');
      return true;
    break;
    case 29: //INVIDEO Звонок (клик по номеру телефона)
      yaCounter50277295.reachGoal('call');
      return true;
    break;
    case 30: //лендинг тариф Игровой успешная отправка заявки
      yaCounter50276626.reachGoal('zayavka');
      return true;
    break;
    case 31: //лендинг тариф Игровой Переход на сайт Инсис
      yaCounter50276626.reachGoal('site_insys');
      return true;
    break;
    case 32: //лендинг тариф Игровой Переход на сайт Steam
      yaCounter50276626.reachGoal('site_steam');
      return true;
    break;
    case 33: //Гарант, Интернет успешная отправка заявки
      ym(51631811, 'reachGoal', 'zayavka_inet');
      ym(51631811, 'userParams', params);
      return true;
    break;
    case 34: //Гарант, КТВ успешная отправка заявки
      ym(51631811, 'reachGoal', 'zayavka_tv', params);
      ym(51631811, 'userParams', params);
      return true;
    break;
    case 35: //Гарант, Видеонаблюдение успешная отправка заявки
      ym(51631811, 'reachGoal', 'zayavka_video', params);
      ym(51631811, 'userParams', params);
      return true;
    break;
    case 36: //Гарант, Доп.услуги успешная отправка заявки
      ym(51631811, 'reachGoal', 'zayavka_dopuslugi', params);
      ym(51631811, 'userParams', params);
      return true;
    break;
    case 37: //Гарант, Без выбора услуги успешная отправка заявки
      ym(51631811, 'reachGoal', 'podkluchaysia_main', params);
      ym(51631811, 'userParams', params);
      return true;
    break;
    case 38: // Лендинг Видеонаблюдение. Совершенный дизайн. Заявка
      yaCounter55980658.reachGoal('zayavka');
      return true;
    break;
    case 39: // Лендинг Видеонаблюдение. Совершенный дизайн. Демоверсия
      yaCounter55980658.reachGoal('demo');
      return true;
    break;
    case 40: //Profintel клик по кнопке "ozon" «ТВ приставка»
      yaCounter623317.reachGoal('ozon_zayavka');
      return true;
    break;
  }
}
